/**
 * Ad Block Ninja — ad blocker
 *
 * Exposes exactly one web-accessible resource, `pages/popup-tracker.html`, matched to
 * <all_urls> with no `use_dynamic_url` — so it resolves from any page at a fixed URL.
 * With a single WAR there is no corroborating path, but the one that exists is a stable,
 * vendor-specific filename served only when the extension is installed, which makes a
 * successful fetch conclusive.
 *
 * Manifest verified against version 2.2.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'ppfadpgpccljindldolejmgkhgaficka';

export const adBlockNinja: ExtensionDefinition = {
  id: ID,
  name: 'Ad Block Ninja',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 100_000,
  notes:
    'A single static WAR (pages/popup-tracker.html) on <all_urls>, no dynamic URL. ' +
    'One path only, but a successful fetch is conclusive.',
  signals: [
    {
      id: 'war-popup-tracker-html',
      kind: 'web-accessible-resource',
      description:
        'Fetch pages/popup-tracker.html — the extension\'s only web-accessible ' +
        'resource, exposed to every origin at a fixed URL.',
      weight: 1,
      run: () => probeFetch(ID, 'pages/popup-tracker.html'),
    },
  ],
};
